<template>
  <v-card class="card-container">
    <div class="main-toolbar">
      <div class="icon-back">
        <v-img src="../../../assets/figmaIcons/white/tasks.svg" max-width="55%"></v-img>
      </div>
      <span class="main-toolbar-title">Integrações</span>
      <v-spacer></v-spacer>
    </div>

    <div class="mt-4">
      <v-tabs
        v-model="tab"
        :height="40"
        :mobile-break-point="360"
        icons-and-text
        grow
        class="ma-0 rounded-lg"
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>

        <v-tab active-class="activated-tab" href="#chaves" class="rounded-lg rounded-b-0">
          Chaves de API
          <v-icon class="mt-1 mr-2">mdi-key-outline</v-icon>
        </v-tab>

        <v-tab active-class="activated-tab" href="#docs" class="rounded-lg rounded-b-0">
          Documentação
          <v-icon class="mt-1 mr-2">mdi-book-open-outline</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="chaves">
          <api-keys />
        </v-tab-item>

        <v-tab-item value="docs">
          <documentation />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-card>
</template>

<script>
import ApiKeys from './components/ApiKeys.vue'
import Documentation from './components/Documentation.vue'

export default {
  name: 'IntegrationsPage',
  components: { ApiKeys, Documentation },
  data() {
    return {
      tab: 'chaves',
    }
  },
}
</script>
